import { render, staticRenderFns } from "./linksForm.vue?vue&type=template&id=584c7f7c&scoped=true&"
import script from "./linksForm.vue?vue&type=script&lang=js&"
export * from "./linksForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c7f7c",
  null
  
)

export default component.exports